import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {template} from './template';
import css from './index.inline.styl';

export class ReportHeader extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      title: `string`,
      description: `string`,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
    };
  }
}

export const ReportHeaderEl = defineAndMakeJsxFactory(`mp-report-header`, ReportHeader);
export const ReportHeaderReact = panel2react(`mp-report-header`, ReportHeader);
